angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/company/:companyOid/opaquerate", {
        template: '<opaque-rate-component></opaque-rate-component>',
        title: 'opaqueRate.TITLE',
        sidebar: 'priceAndAvailability'
    }).when("/company/:companyOid/opaquerate/add", {
        template: '<opaque-rate-add-component></opaque-rate-add-component>',
        title: 'opaqueRate.TITLE',
        sidebar: 'priceAndAvailability'
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/opaque-rate/opaque-rate.route.js
// module id = 832
// module chunks = 3